export default __webpack_public_path__ + "static/media/6.6e0bb5c6.jpg";